<section class="auth-login">
  <h1 class="auth-welcome">{{ "login.welcomeBack" | translate }}</h1>

  <div class="auth-stack">
    <button class="auth-btn auth-btn-social" [disabled]="redirecting" (click)="loginWithGoogle()">
      <img src="/assets/img/google-logo.svg" alt="Google Logo" class="auth-icon" />
      {{ (redirecting ? "login.redirecting" : "login.google") | translate }}
    </button>

    <button class="auth-btn auth-btn-social" [disabled]="redirecting" (click)="loginWithMicrosoft()">
      <img src="/assets/img/microsoft-logo.svg" alt="Microsoft Logo" class="auth-icon" />
      {{ (redirecting ? "login.redirecting" : "login.microsoft") | translate }}
    </button>
  </div>

  <div class="auth-divider">
    <span>{{ "login.or" | translate }}</span>
  </div>

  <div class="auth-stack">
    <input
      type="email"
      [(ngModel)]="email"
      [placeholder]="'login.emailPlaceholder' | translate"
      class="auth-input"
      (keyup.enter)="sendEmailLink()"
    />

    <button class="auth-btn auth-btn-primary" (click)="sendEmailLink()" [disabled]="sending || !email || redirecting">
      {{ (sending ? "login.sending" : "login.email") | translate }}
    </button>
  </div>

  <p class="auth-feedback auth-feedback-success" *ngIf="successMessage">{{ successMessage }}</p>
  <p class="auth-feedback auth-feedback-error" *ngIf="errorMessage">{{ errorMessage }}</p>
</section>
